import { lazy } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { Box, Container, Typography } from '@mui/material';
import { VM } from '../VM';

import { Index as ToolCategories } from '../../_business/components/toolcategories/Index';
import { RenderAPI } from '../../_business/components/global/RenderAPI';
import { Switching } from '../../_business/components/swtiching/Index'
import { Settings } from '../../_business/components/settings/Index';
import { Index as WSPOFI } from '../../_business/components/website/Index'
// import { TourPersonalization } from '../../_business/components/personalization/tourpersonalization/Index';
import { TourPersonalization } from '../../_business/components/personalization/tourpersonalization/Index';
// FOR SALEPALGE REALPROPERTY
import View from '../../_business/components/campaign/salespage/realproperty/view/Index';
import FacebookSettings from '../../_business/components/facebookSettings/Index';
import {FacebookPosts} from '../../_business/components/reports/facebookPosts/Index';
import { FacebookCallback } from '../../_business/components/facebookSettings/FacebookCallback';

let view = VM();
const Navigation = lazy(() => import(`../../_business/components/layouts/navigations${view}/Index`))
const Home = lazy(() => import (`../../_business/components/home${view}/Index`))
const Campaign = lazy(() => import (`../../_business/components/campaign${view}/Index`))
const Customization = lazy(() => import (`../../_business/components/campaign${view}/customization/Index`))
const PromoBooking = lazy(() => import (`../../_business/components/campaign/promo/booking/customization/Index`))
const CustomProduct = lazy(() => import (`../../_business/components/campaign/promo/product/customization/Index`))
const Setup = lazy(() => import (`../../_business/components/setup${view}/Index`))
const SetupCustomization = lazy(() => import (`../../_business/components/setup${view}/customization/Index`))
const OnlineSolutions = lazy(() => import (`../../_business/components/onlinesolutions${view}/Index`))
const OLCustomization = lazy(() => import (`../../_business/components/onlinesolutions${view}/customization/Index`))
const Sales = lazy(() => import (`../../_business/components/sales${view}/Index`))
const Reports = lazy(() => import (`../../_business/components/reports${view}/Index`))
const LeadsManagement = lazy(() => import (`../../_business/components/leadsmanagement${view}/Index`))
const Move = lazy(() => import(`../../_business/components/sales/booking/move${view}/Index`))
const CustomizationProperty = lazy(() => import (`../../_business/components/campaign${view}/salespage/realproperty/customize/Index`))
const Profile = lazy(() => import (`../../_business/components/profile${view}/Index`))

export const WebRoute = () => {
    const location = useLocation().pathname;

    return (
        <Switch>
            {/* HOME */}
			<Route exact path="/" render={props=>(Render(Home, props, location))}/>
            <Route exact path="/switching" render={props=><Switching/>} />
            <Route exact path="/more" render={props=>(Render(Settings, props, location))} />
            <Route exact path="/tool-categories/:params" render={props=>(Render(ToolCategories, props, location))} />

			{/* CAMPAIGN */}
			<Route exact path="/campaign/:cstep" render={props => (Render(Campaign, props, location))} />
           
			{/* CAMPAIGN -> CUSTOMIZATION PAGES  */}
			<Route exact path="/campaign/:setup/customize" render={props => (Render(Customization, props, location))}/>

			{/* CAMPAIGN FOR REAL PROPERTY SALES PAGE CUSTOMIZATION - TEMPORARY */}
			<Route exact path="/campaign/sales_page/real_property/attract/templates/customization/:action" render={props => (Render(CustomizationProperty, props, location))} />
            {/* CAMPAIGN FOR REAL PROPERTY SALE PAGE VIEW */}
            <Route exact path="/campaign/sales_page/real_property/view" render={props => (Render(View, props, location))} />
            {/* CAMPAIGN PROMO BOOKING CUSTOMIZATION */}
            <Route exact path="/campaign/promo/service/customization" render={props => (Render(PromoBooking, props, location))} />
            {/* CAMPAIGN PROMO PRODUCT CUSTOMIZATION */}
            <Route exact path="/campaign/promo/product/customization" render={props => (Render(CustomProduct, props, location))} />
			{/* SALES */}
			<Route exact path="/sales/:subfeature" render={props => (Render(Sales, props, location))} />
            {/* SALES FOR BOOKING VIEW */}
            <Route exact path="/sales/booking/action/move/:bid" render={props => (Render(Move, props, location))} />

			{/* LEADS MANAGEMENT */}
			<Route exact path="/lm/:subfeature" render={props => (Render(LeadsManagement, props, location))} />

			{/* SETUP */}
			<Route exact path="/setup/:subfeature" render={props => (Render(Setup, props, location))} />

			{/* SETUP -> FULL PAGE SETUP */}
			<Route exact path="/setup/:subfeature/customize" render={props => (Render(SetupCustomization , props, location))} />

			{/* ONLINE SOLUTIONS */}
			<Route exact path="/ol/:subfeature" render={props => (Render(OnlineSolutions, props, location))} />

			{/* ONLINE SOLUTIONS -> FULL PAGE SETUP */}
			<Route exact path="/ol/:subfeature/customize" render={props => (Render(OLCustomization , props, location))} />

			{/* REPORTS */}
			<Route exact path="/reports/:subfeature" render={props => (Render(Reports, props, location))} />

            {/*Facebook Integration Settings*/}
            <Route exact path="/integrations/facebook-settings" render={props => (Render(FacebookSettings, props, location))} />
            <Route exact path="/reports/facebook-posts" render={props => (Render(FacebookPosts, props, location))} />
            <Route exact path="/facebook/callback" render={props => (Render(FacebookCallback, props, location))} />

			{/* WEBSITE */}
			<Route exact path="/ws/:orgname/:feature" render={props => (<WSPOFI {...props}/>)} />

			{/* PROFILE */}
			<Route exact path="/profile" render={props => (Render(Profile, props, location))} />

            {/* 404 NOT FOUND */}
            <Route>
                <Container>
                    <Box display="flex">
                        Error 404
                    </Box>
                </Container>
            </Route>
        </Switch>
    )
}

const __LOCATION = window.location.pathname;
const excludedLocationsSB = [ // SB = SIDEBAR, HIDE SB
	'/campaign/promo/product/customization',
	'/campaign/website/customization',
	'/campaign/sales_page/real_property/attract/templates/customization/create',
	'/campaign/sales_page/real_property/attract/templates/customization/update',
	'/campaign/sales_page/real_property/view',
	'/realproperty/view',
	'/realproperty/setup',
	'/website',
	'/campaign/poster/customize',
	'/campaign/training-poster/customize',
	'/campaign/website/customize',
	'/setup/real-property/customize',
	'/ol/ecs/customize',
]
const excludedLocationsTB = [ // TB = TOPBAR, HIDE TB
	'/campaign/promo/product/customization',
	'/campaign/poster/customize',
	'/campaign/training-poster/customize',
    '/campaign/promo/service/customization',
]
const isExcluded = (list, loc) => list.some((exc) => loc === exc || loc.startsWith(exc));
const hcrmSession = JSON.parse(localStorage.getItem('hcrm_session'))
const Render = (Component, props, location) => (
    <>
        {view === '' ? (
			<Box width="100%" height="100%">
                <Box width="100%" height="100%" display="flex">
                    <Box height="100%">
						{__LOCATION.split('/')[1] !== 'website' && __LOCATION.split('/')[1] !== 'l' && __LOCATION.split('/')[1] !== 'prev' && !isExcluded(excludedLocationsSB, location) && (<Navigation side={1} />)}
                    </Box>
                    <Box display="flex" flexDirection="column" width="100%" height="100%" className="overflowX">
						{__LOCATION.split('/')[1] !== 'website' && __LOCATION.split('/')[1] !== 'l' && __LOCATION.split('/')[1] !== 'prev' && !isExcluded(excludedLocationsTB, location) && <Navigation side={0} />}
                        <Box height="100%" width="100%" className="overflowY" bgcolor="#F5F5F5">
                            <Component {...props} />
							{/* <TourMsg /> */}
							{ hcrmSession !== null && <TourPersonalization/> }
                        </Box>
                    </Box>
                </Box>
            </Box>
    ) : (
            <Box
                width="100%"
                height="100vh"
                display="flex"
                alignItems="center"
                justifyContent="center"
                px={2}
                bgcolor="#f9fafb"
                >
                <Box
                    maxWidth={360}
                    width="100%"
                    textAlign="center"
                    p={3}
                    borderRadius={2}
                    boxShadow={1}
                    bgcolor="#ffffff"
                >
                    <Typography variant="h6" fontWeight={600} gutterBottom>
                        Desktop or Laptop Required
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                        HRC is only available on desktop devices.
                    <br />
                        Please use your laptop or computer to proceed.
                    </Typography>
                </Box>
                {/* {(location !== '/biz/profiling' && location !== '/biz/more') && (
                        <Box minHeight={location === '/biz' ? '92px' : '40px'}>
                            <Navigation side={0} />
                        </Box>
                    )}
                    <Box height="100%" width="100%" className="overflowY noScrollcss"><Component {...props} /></Box>
                    {(location !== '/profile' && location !== '/biz/profiling') &&
                        <Box minHeight="54px">
                            <Navigation side={2} />
                        </Box>
                    }  */}
            </Box>
            
        )}
        <RenderAPI/>
    </>
)
